import * as React from 'react';

import Bs4Kartoteka from './Bs4Kartoteka'
import Bs4ReportGeneric from './Bs4Report/Bs4ReportGeneric'
import Bs4ReportType1 from './Bs4Report/Bs4ReportType1'
import Bs4ReportType41 from './Bs4Report/Bs4ReportType41'
import Bs4ReportType53 from './Bs4Report/Bs4ReportType53'
import Bs4ReportType55 from './Bs4Report/Bs4ReportType55'
import Bs4ReportType42 from './Bs4Report/Bs4ReportType42'
import Bs4ReportType35 from './Bs4Report/Bs4ReportType35'
import Bs4ReportTypeInfinityBox from './Bs4Report/Bs4ReportTypeInfinityBox'
import Bs4ReportTypeTabelka from './Bs4Report/Bs4ReportTypeTabelka'
import Bs4ReportType46 from './Bs4Report/Bs4ReportType46'
import Bs4ReportType49 from './Bs4Report/Bs4ReportType49'
import Bs4ReportType51 from './Bs4Report/Bs4ReportType51'

import Bs4Form from './Bs4Form/Bs4Form'

export default function bs4OptionBinding(props) {
  const bs4Option = {
    ...props,    
    getMainObject: function() {
      if (this.bs4Grid) return this.bs4Grid;
      if (this.bs4Form) return this.bs4Form;
    }
  };
  const bs4Kartoteka = Bs4Kartoteka.get(props.bs4KartotekaId);
  props.bs4ConstructorMode = {};
  props.bs4ConstructorMode.enabled = bs4Kartoteka.message._Komunikat.bs4ConstructorMode;
  bs4Kartoteka.addBs4Option(props.optionId, bs4Option);
  
  switch (props.optionType) {
    case '1':
    case '9':
    //case '46':
      bs4Option.bs4Grid = new Bs4ReportType1(props);
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '35':
      bs4Option.bs4Grid = new Bs4ReportType35(props);     
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '41':
      bs4Option.bs4Grid = new Bs4ReportType41(props);      
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '46':
      bs4Option.bs4Grid = new Bs4ReportType46(props);
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '1000024':
      bs4Option.bs4Grid = new Bs4ReportType42(props);      
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '42':
      bs4Option.bs4Grid = new Bs4ReportType42(props);      
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '49':
      bs4Option.bs4Grid = new Bs4ReportType49(props);
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '51':
      bs4Option.bs4Grid = new Bs4ReportType51(props);
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '53':
      bs4Option.bs4Grid = new Bs4ReportType53(props);  
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '55':
      bs4Option.bs4Grid = new Bs4ReportType55(props);  
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case '2':
      bs4Option.bs4Form = new Bs4Form(props, false)
      bs4Option.bs4Form.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Form.ViewComponent;
      break;

    case 'infinity':
      //bs4Option.bs4Grid = new Bs4ReportTypeInfinity(props)
      bs4Option.bs4Grid = new Bs4ReportTypeInfinityBox(props)
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    case 'tabelka':
      bs4Option.bs4Grid = new Bs4ReportTypeTabelka(props)
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;

    default:
      bs4Option.bs4Grid = new Bs4ReportGeneric(props);
      bs4Option.bs4Grid.createModel();
      bs4Option.ViewComponent = bs4Option.bs4Grid.ViewComponent;
      break;
  } 

  return bs4Option;
}